/**
 * O HOOK QUE FAZ A TROCA DE IDIOMA REDESENHAR A TELA.
 *
 * O DEFEITO QUE ELE FECHA, medido em 08/09/2026 na tela do admin: clicar EN gravava o
 * cookie, trocava o `lang` do documento para `en-US` e movia o `aria-pressed` do botao. Tudo
 * indicava que a troca tinha funcionado. E NENHUM TEXTO MUDAVA. So um reload trazia o
 * ingles.
 *
 * A CAUSA E SIMPLES E INVISIVEL: `t()` le o dicionario no momento em que o componente
 * renderiza. Trocar o idioma nao renderiza nada por conta propria, entao a tela continua
 * mostrando o resultado da renderizacao anterior, feita no idioma antigo. Nao ha erro, nao
 * ha aviso, e a unica pista e o texto que nao muda.
 *
 * POR QUE ELE MORA AQUI, e nao em `@complexity/i18n`: aquele pacote e PURO, sem React, e
 * acopla-lo a uma biblioteca de interface para hospedar um hook seria pagar caro por
 * conveniencia. Aqui ja ha React, e este e o pacote das pecas de tela.
 *
 * E POR QUE ELE PRECISOU EXISTIR: o mesmo hook estava escrito a mao em DOIS lugares
 * (`apps/voe/src/i18n/ligar.ts` e `packages/ia-extrato/src/components/PainelExtratoIa.tsx`),
 * e um terceiro estava prestes a nascer no admin. Tres copias do mesmo laco de assinatura e
 * a definicao de duplicata que esta casa proibe: a correcao de uma nao chega nas outras, e
 * o app que esquecesse de copiar ficaria com a tela que nao redesenha, exatamente como o
 * admin ficou.
 */
import { useEffect, useState } from 'react';
import { assinarIdioma, idiomaAtual, type Idioma } from '@complexity/i18n';

export function useIdiomaVivo(): Idioma {
  // O ESTADO NASCE COM O IDIOMA ATUAL, e nao com o padrao: quem chega com o cookie ja em
  // ingles precisa ver a primeira pintura em ingles, e nao um piscar de portugues.
  const [idioma, setIdioma] = useState<Idioma>(() => idiomaAtual());

  // `assinarIdioma` devolve a propria funcao de cancelar, entao devolve-la e a limpeza.
  // Sem isso, cada montagem somaria um ouvinte que nunca sai, e depois de algumas navegacoes
  // uma troca de idioma dispararia varias renderizacoes em cascata.
  useEffect(() => assinarIdioma(setIdioma), []);

  return idioma;
}
